import {action, getter, Module, mutation, VuexModule} from "vuex-class-component"

@Module({namespacedPath: "ui/"})
export default class UIModule extends VuexModule {

  @action()
  async initialize() {
    const resize = () => {
      this.setShowMenu(window.innerWidth > 780)
    }
    window.addEventListener("resize", resize)
    resize()
  }

  // region サイドメニュー

  @getter
  public show_menu: boolean = true

  @mutation
  setShowMenu(val: boolean) {
    this.show_menu = val
  }

  @action()
  async showSideNavi(): Promise<void> {
    this.setShowMenu(true)
  }

  @action()
  async hideSideNavi(): Promise<void> {
    this.setShowMenu(false)
  }

  // endregion
}